import React from "react";
import AdmMain from "../../components/Admin/AdmMain.jsx";
import { LanguageContext } from "../../context/LanguageContext.jsx";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/LoginContext";
// import useFetch from "../../hook/useFetch";

export default function Adm() {
  const { language } = useContext(LanguageContext);
  const { user } = useAuth();
  return (
    <>
      <AdmMain language={language} user={user} />
      <Outlet />
    </>
  );
}
